"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMapPoint = exports.CIRCLE_SIZE_PX = exports.CIRCLE_RADIUS = exports.CSS = void 0;
exports.view = view;
const core_shared_1 = require("@ikegps/core-shared");
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
const dom_1 = require("../../dom");
const mithril_1 = require("../../mithril");
const page_state_1 = require("../../state/page.state");
exports.CSS = {
    container: 'c-MapTag',
    point: 'c-MapTag__point',
    title: 'c-MapTag__title',
    isHovered: 'c-MapTag--is-hovered',
    isSelected: 'c-MapTag--is-selected'
};
exports.CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 4;
exports.CIRCLE_SIZE_PX = exports.CIRCLE_RADIUS * 2 + 'px';
(0, theme_1.addStyles)({
    [exports.CSS.point]: {
        height: exports.CIRCLE_SIZE_PX,
        width: exports.CIRCLE_SIZE_PX,
        minWidth: exports.CIRCLE_SIZE_PX,
        maxWidth: exports.CIRCLE_SIZE_PX,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        textShadow: theme_1.DefaultTheme.shadow.text,
        position: 'absolute',
        cursor: 'pointer',
        color: theme_1.DefaultTheme.font.color.white,
        border: `2px solid ${theme_1.DefaultTheme.font.color.white}`
    },
    [exports.CSS.title]: {
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
        backgroundColor: '#FFF',
        height: theme_1.DefaultTheme.space(6),
        lineHeight: theme_1.DefaultTheme.space(6),
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        fontSize: '125%',
        position: 'absolute',
        width: '120px',
        padding: '4px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'center',
        whiteSpace: 'no-wrap'
    },
    [`${exports.CSS.point}.${exports.CSS.isHovered}`]: {
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2w5
    },
    [exports.CSS.isHovered]: {
        zIndex: 99
    },
    [exports.CSS.isSelected]: {
        boxShadow: `0 0 0 3px rgba(${theme_palette_1.ColorPaletteOrange.C700}, 0.24), 0 0 0 3px rgba(${theme_palette_1.ColorPaletteOrange.C700}, 0.64)`
    },
    [`${exports.CSS.point}.${exports.CSS.isHovered}.${exports.CSS.isSelected}`]: {
        boxShadow: `0 0 0 5px rgba(${theme_palette_1.ColorPaletteOrange.C700}, 0.24), 0 0 0 5px rgba(${theme_palette_1.ColorPaletteOrange.C700}, 0.64)`
    }
});
function view(tag, summary, point) {
    const isHovered = page_state_1.CurrentState.hoverId === tag.objectId;
    const isSelected = page_state_1.CurrentState.Tag.isTagSelected(tag.objectId);
    const domPoint = (0, mithril_1.m)('div', {
        key: tag.objectId,
        [dom_1.DRAGON_ID]: tag.objectId,
        [dom_1.DRAGON_TYPE]: dom_1.DragonDomTypes.TAG,
        className: `${exports.CSS.point} ${isHovered ? exports.CSS.isHovered : ''} ${isSelected ? exports.CSS.isSelected : ''}`,
        style: {
            backgroundColor: core_shared_1.ColorHash.hash(tag.objectId),
            top: point.y - exports.CIRCLE_RADIUS + 'px',
            left: point.x - exports.CIRCLE_RADIUS + 'px'
        }
    }, summary.revisions.length);
    if (isHovered) {
        return (0, mithril_1.m)('div', [
            domPoint,
            (0, mithril_1.m)('div', {
                [dom_1.DRAGON_ID]: tag.objectId,
                [dom_1.DRAGON_TYPE]: dom_1.DragonDomTypes.TAG,
                className: `${exports.CSS.title} ${exports.CSS.isHovered}`,
                style: {
                    top: point.y - theme_1.DefaultTheme.spacingFactor * 14 + 'px',
                    left: point.x - 60 + 'px'
                }
            }, tag.name)
        ]);
    }
    return domPoint;
}
exports.TagMapPoint = { view, Radius: exports.CIRCLE_RADIUS };
//# sourceMappingURL=point.tag.js.map